import React from "react";
import {useEffect, useState} from "react";
import Text from "@amzn/meridian/text";
import { PropTypes } from 'prop-types';
import {getCurrentFormattedTime} from "../util/CommonUtils";
import {FormattedMessage, injectIntl} from "react-intl";

/**
 * React component for getting the last refresh time in a page
 * @param deps
 * @param locale
 * @return JSX.Element
 */
const RefreshTimer = ({deps, intl}) => {
    const [latestRefreshTime, setRefreshTime] = useState("");
    useEffect(() => {
        setRefreshTime(getCurrentFormattedTime(intl.locale));
    }, deps);

    return (
        <Text type="b200">
            <FormattedMessage id="commons.data_last_updated" defaultMessage="Data last updated"/>: {latestRefreshTime}
        </Text>
    )
}

RefreshTimer.propTypes = {
    deps: PropTypes.array,
    locale: PropTypes.string,
};

export default injectIntl(RefreshTimer)


// WEBPACK FOOTER //
// ./src/commons/RefreshTimer.js